import request from "../../network/request"
const user = {
    state: {
        token: '', // 令牌信息
        name: '', // 用户名称
        // avatar: '',
        taskPermission: '', // 是否有发布任务的权限
        role: null, // 角色信息
        isordinary: false, //是否普通学校
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
            LYCom.SetToken(token);
            // sessionStorage.setItem("token", token);
            // sessionStorage.setItem("token", token);
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        set_isordinary: (state, isordinary) => {
            state.isordinary = isordinary
        },
        // SET_AVATAR: (state, avatar) => {
        //     state.avatar = avatar
        // },
        SET_ROLE: (state, role) => {
            state.role = role;
            state.taskPermission = role.taskPermission
        }
    },
    actions: {

        // 获取用户信息
        GetInfo({
            commit,
            state
        }) {
            return new Promise(async (resolve, reject) => {

                try {
                    let data = await request.get("educationadmin/getUserInfo", {}); // 当前用户信息
                    // let data = LYCom.CallBiz("SysMgrBiz", "GetUserInfo", sessionStorage.getItem("token"));

                    if (data != null) {
                        let currentEnterOrgInfo = window.sessionStorage.getItem('currentEnterOrgInfo');
                        let loginInfos=data.userInfo;
                        loginInfos.educationOrganizationId = data.educationOrganizationId;
                        window.sessionStorage.setItem('loginInfos', JSON.stringify(loginInfos)); // 登录信息
                        if (currentEnterOrgInfo) {
                            currentEnterOrgInfo = JSON.parse(currentEnterOrgInfo);
                            commit("set_isordinary", currentEnterOrgInfo.ordinary)

                        } else {
                            commit("set_isordinary", data.ordinary)
                        }
                        commit("SET_NAME", data.organizationName);
                        commit('SET_ROLE', {
                            "role_id": data.userInfo.roleId,
                            "educationOrganizationId":data.educationOrganizationId,
                            "role_name": data.userInfo.displayName,
                            "role_group": data.currentRoleGroup,
                            'displayName': data.userInfo.displayName,
                            "taskPermission": data.userInfo.permission
                        });
                    }

                    resolve(data);
                } catch (e) {
                    window.sessionStorage.removeItem('LyToken')
                    reject(e);
                }
            })
        },
        /**
         * 登出
         * @param commit
         * @param state
         * @returns {Promise<any>}
         * @constructor
         */
        LogOut({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                let rtn = LYCom.CallBiz("SysMgrBiz", "LoginOut", LYCom.GetToken());
                // if(rtn) {
                commit('SET_TOKEN', '');
                commit('SET_ROLE', null);
                LYCom.RemoveToken();
                resolve();
                // }
            });
        },

        /**
         * 前端 登出
         * @param commit
         * @returns {Promise<any>}
         * @constructor
         */
        FedLogOut({
            commit
        }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                LYCom.RemoveToken();
                resolve()
            })
        }
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js